export default __webpack_public_path__ + "static/media/gradient.243dd4eb.png";